<div *ngIf="isLoading">
    <ng-container>
        <div class="overlay-layer bg-transparent matspinner">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading">

    <button mat-icon-button class="matdialog-close-btn" [mat-dialog-close]="true">
        <mat-icon class="close-icon">close</mat-icon>
    </button>

    <!-- <h1 mat-dialog-title>{{artikelData.name}}</h1> -->
    <div mat-dialog-content>

        <div class="content">
            <div fxLayout="row" fxLayoutGap="16px grid" fxLayoutAlign="center center">

                <div fxFlex="15" align="center">
                    <kkis-app-artikelbild-thumbs1 [artikelBilder]="artikelBilder" (selectedImage)="getSelectedImage($event)" [isVertical]="true"></kkis-app-artikelbild-thumbs1>
                </div>

                <div fxFlex="40" fxLayoutAlign="center center">
                    <img src="data:image/jpeg;base64,{{selectedImgFile}}" *ngIf="selectedImgFile != null" />
                    <img src="{{imgDummy}}" *ngIf="artikel.bild == null && selectedImgFile == null" style="max-height: 50%; max-width: 50%" />
                </div>

                <div fxFlex="45" >
                    <div class="kt1">{{artikel.name}}</div>
                    <div class="kt2">{{artikel.name2}}</div>
                    <!-- <div class="price">
                        {{preis | currency: 'EUR' : 'symbol'}}
                    </div> -->

                    <div class="price mt-2" *ngIf="artikel.wS_Ohneverrechnung == 1" style="display: flex;">
                        <div class="info"></div><span>Preis auf Anfrage!</span>
                    </div>

                    <div class="price mt-2" style="display: flex;" *ngIf="artikel.anzeigeNetto != null && artikel.wS_Ohneverrechnung != 1">
                        <!-- Netto {{(selectedArtikel == null ? artikel.vkPreis_E1 : selectedArtikel.vkPreis_E1) | currency: 'EUR'}} -->
                        <!--Netto {{(selectedArtikel == null ? artikel.anzeigeNetto : selectedArtikel.anzeigeNetto)}} <span>€</span>-->
                        <!--<span [innerHTML]="artikel.anzeigeNetto"></span><span>&nbsp;€</span>-->
                        <div [innerHTML]="selectedArtikel == null ? 'Netto ' + artikel.anzeigeNetto + '&nbsp;€': 'Netto ' + selectedArtikel.anzeigeNetto + '&nbsp;€'"></div>
                        <div class="info_vpe" *ngIf="artikel.perEinheit > 1" [innerHTML]="selectedArtikel == null ? '(' + preis_netto + '&nbsp;€/'+ artikel.perEinheit + ' '+ artikel.einheit + ')' : '(' + selectedArtikel.preisNetto + '/'+ selectedArtikel.perEinheit + ' '+ selectedArtikel.einheit + ')'"></div>
                        <div class="priceinfo_staffel" *ngIf="artikel.staffelpreisVorhanden == true && artikel.festpreisNutzen != true" title="Staffelpreis vorhanden - klicken für Übersicht" (click)="onShowStaffel()"></div>
                        <span class="info_staffelpreis" *ngIf="artikel.staffelpreisVorhanden == true && artikel.festpreisNutzen != true">Staffelpreis</span>
                    </div>

                    <div id="view_staffelpreise"></div>
                    
                    <div class="price mt-2" style="display: flex;" *ngIf="artikel.anzeigeBrutto != null && artikel.wS_Ohneverrechnung != 1">
                        <div *ngIf="artikel.anzeigeBrutto != null" [innerHTML]="selectedArtikel == null ? 'Brutto ' + artikel.anzeigeBrutto + '&nbsp;€': 'Brutto ' + selectedArtikel.anzeigeBrutto + '&nbsp;€'">
                            <!-- Brutto {{(selectedArtikel == null ? artikel.bruttoPreis_E1 : selectedArtikel.bruttoPreis_E1) | currency: 'EUR'}} -->
                            <!-- Brutto {{(selectedArtikel == null ? artikel.anzeigeBrutto : selectedArtikel.anzeigeBrutto)}} <span>€</span> -->
                        </div>
                        <div class="info_vpe" *ngIf="artikel.perEinheit > 1" [innerHTML]="selectedArtikel == null ? '(' + preis_brutto + '&nbsp;€/'+ artikel.perEinheit + ' '+ artikel.einheit + ')' : '(' + selectedArtikel.preisBrutto + '/'+ selectedArtikel.perEinheit + ' '+ selectedArtikel.einheit + ')'">
                        </div>
                    </div>

                    <div *ngIf="artikel.rabattfaehig_JN=='J' && artikel.rabatt != null && artikel.rabatt > 0 && artikel.preisNetto > 0">
                        <span>(inkl. {{artikel.rabatt}}% Rabatt)</span>
                    </div>

                    <div *ngIf="artikeloptions.display_artnr==true" class="mt-4">
                        Art. Nr. {{selectedArtikel == null ? artikel.nr : selectedArtikel.nr}}
                    </div>
                    <div *ngIf="artikel.artNrKunde != '' && artikel.artNrKunde != null && artikeloptions.display_artnr==true" class="mt-4">
                        Kunden Art. Nr. <span class="kundartnr">{{selectedArtikel == null ? artikel.artNrKunde : selectedArtikel.artNrKunde}}</span>
                    </div>                    
                    <div *ngIf="artikel.herstellerNr != '' && artikel.herstellerNr != null && artikeloptions.display_herstellernr==true" class="mt-4">
                        Hersteller Nr. {{selectedArtikel == null ? artikel.herstellerNr : selectedArtikel.herstellerNr}}
                    </div>
                    <div *ngIf="artikel.mCode1 != '' && artikel.mCode1 != null && artikeloptions.display_mcode1==true" class="mt-2">
                        {{artikeloptions.lbl_mcode1}}: {{selectedArtikel == null ? artikel.mCode1 : selectedArtikel.mCode1}}
                    </div>
                    <div *ngIf="artikel.mCode2 != '' && artikel.mCode2 != null && artikeloptions.display_mcode2==true" class="mt-2">
                        {{artikeloptions.lbl_mcode2}}: {{selectedArtikel == null ? artikel.mCode2 : selectedArtikel.mCode2}}
                    </div>

                    <mat-divider class="p-2 mt-2"></mat-divider>

                    <div class="textOverflow linebreak">
                    <!-- <div class="textOverflow linebreak"></div> -->
                        {{selectedArtikel == null ? artikel.text : selectedArtikel.text}}
                    </div>

                    <mat-divider class="p-2 mt-2"></mat-divider>

                    <div fxLayout="row wrap" fxLayoutGap="16px grid" fxLayoutAlign="end">

                        <div fxFlex="{{dropdownboxesWidth}}" *ngIf="isLoadingMatrix">
                            <div  *ngIf="isLoadingMatrix" class="overlay overlay-block cursor-default modal-body">
                                <ng-container>
                                    <div class="overlay-layer bg-transparent">
                                        <div class="spinner spinner-lg spinner-success"></div>
                                    </div>
                                </ng-container>
                            </div>  
                        </div>

                        <div fxFlex="{{dropdownboxesWidth}}" *ngIf="groessen != null && groessen.length > 0 && !isLoadingMatrix">
                            <mat-form-field appearance="fill">
                                <mat-label>Grösse</mat-label>
                                <mat-select [(ngModel)]="selectedGroesse" name="groesse" (selectionChange)="onGroesseChanged($event)" required>
                                    <mat-option *ngFor="let g of groessen" [value]="g">
                                        {{g.groesse_Wert}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="!selectedGroesse">{{getErrorMessageRequired("Grösse")}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div fxFlex="{{dropdownboxesWidth}}" *ngIf="isLoadingMatrix">
                            <div  *ngIf="isLoadingMatrix" class="overlay overlay-block cursor-default modal-body">
                                <ng-container>
                                    <div class="overlay-layer bg-transparent">
                                        <div class="spinner spinner-lg spinner-success"></div>
                                    </div>
                                </ng-container>
                            </div>  
                        </div>

                        <div fxFlex="{{dropdownboxesWidth}}" *ngIf="farben != null && farben.length > 0 && !isLoadingMatrix">
                            <mat-form-field appearance="fill">
                                <mat-label>Farbe</mat-label>
                                <mat-select [(ngModel)]="selectedFarbe" name="farbe" (selectionChange)="onFarbeChanged($event)" required>
                                    <mat-option *ngFor="let f of farben" [value]="f">
                                        {{f.farbe_Wert}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="!selectedFarbe">{{getErrorMessageRequired("Farbe")}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div fxFlex="{{dropdownboxesWidth}}" fxFlexAlign="end">
                            <mat-form-field appearance="fill" style="width:100%">
                                <mat-label>Menge</mat-label>
                                <input type="number" matInput required min="0" [formControl]="menge" (change)="onChangeMenge($event)" id="menge" required>
                                <mat-hint>{{bestand}} Artikel auf Lager</mat-hint>
                                <!-- <mat-error *ngIf="menge.invalid">{{getErrorMessageMenge()}}</mat-error> -->
                            </mat-form-field>
                        </div>

                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="16px grid" *ngIf="bestand == 0">
                        <div fxFlex class="text-danger mt-2">
                            <span>{{nichtAufLager}}</span>
                        </div>
                    </div>
                
                </div>

            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="16px grid" fxLayoutAlign="center center">
            <div fxFlex="50">
                <kkis-app-artikeldokumente-list [artikelKennung]="selectedArtikel == null ? artikel.id : selectedArtikel.id"></kkis-app-artikeldokumente-list>
            </div>
            
            <div fxFlex="50" mat-dialog-actions align="end" class="mr-8 mt-4">
                <!-- <button [disabled]="!isValid" mat-flat-button color="accent" (click)="onAddToWarenkorb()">In den Warenkorb</button> -->
                <button mat-flat-button color="accent" class="theme-customer-btn" *ngIf="level==1 || (level == 2 && selectedGroesse && selectedFarbe)" (click)="onAddToWarenkorb()">In den Warenkorb</button>
                <!-- <button mat-stroked-button color="accent" >Detailansicht</button> -->
            </div>
        </div>
        
        <div fxLayout="row" fxLayoutGap="16px grid" fxLayoutAlign="center center">
            <div fxFlex="100">            
                <kkis-app-webshop-artikelzubehoer id="container_zubehoer" *ngIf="level==1" [artikelKennung]="selectedArtikel == null ? artikel.id : selectedArtikel.id" [zubehoermulti]="neuemenge"></kkis-app-webshop-artikelzubehoer>
                <kkis-app-webshop-kurse id="container_kurse" *ngIf="level==1" [artikelKennung]="selectedArtikel == null ? artikel.id : selectedArtikel.id" [menge]="neuemenge" style="display:none"></kkis-app-webshop-kurse>
            </div>
        </div>

        <!--
        <div fxLayout="row" fxLayoutGap="16px grid" fxLayoutAlign="center center">
            <div fxFlex="100">            
                <kkis-app-webshop-staffelpreise id="container_staffelpreise" [artikelKennung]="selectedArtikel == null ? artikel.id : selectedArtikel.id"></kkis-app-webshop-staffelpreise>
            </div>
        </div>
    -->

        
    </div>
</div>  